import Vue from "vue";
import Vuex from "vuex";
import cart from "./modules/cart";
import products from "./modules/products";
import common from "./modules/common";
import createPersistedState from "vuex-persistedstate";
// import createLogger from '../../../src/plugins/logger'

Vue.use(Vuex);

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    modules: {
        cart,
        products,
        common
    },
    plugins: [
            createPersistedState({
                paths: ["common.logged", "cart.items"]
            })
        ]
        // strict: debug,
        // plugins: debug ? [createLogger()] : []
});